import {
  Box,
  Checkbox,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { GroupedTrip } from "../types";

interface TripListProps {
  groupedTrips: GroupedTrip[];
  selectedTripIds: Set<string>;
  onToggleTripSelection: (tripId: string) => void;
}

export const TripList: React.FC<TripListProps> = ({
  groupedTrips,
  selectedTripIds,
  onToggleTripSelection,
}) => {
  if (groupedTrips.length === 0) {
    return (
      <Box
        sx={{
          p: 3,
          textAlign: "center",
          color: "text.secondary",
        }}
      >
        <Typography variant="body2">No trips in selected range</Typography>
      </Box>
    );
  }

  return (
    <List
      sx={{
        maxHeight: 300,
        overflowY: "auto",
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        p: 0,
      }}
    >
      {groupedTrips.map((trip, index) => {
        const isChecked = selectedTripIds.has(trip.trip_id);
        const startTime = new Date(trip.start_time);
        const endTime = new Date(trip.end_time);

        return (
          <ListItem
            key={trip.trip_id}
            disablePadding
            sx={{
              borderBottom:
                index < groupedTrips.length - 1 ? 1 : 0,
              borderColor: "divider",
            }}
          >
            <ListItemButton
              dense
              onClick={() => onToggleTripSelection(trip.trip_id)}
              sx={{ py: 0.5 }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Checkbox
                  edge="start"
                  checked={isChecked}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    {trip.tail_number && (
                      <Chip
                        label={trip.tail_number}
                        size="small"
                        sx={{ height: 20 }}
                      />
                    )}
                    <Typography variant="body2" sx={{ flex: 1 }}>
                      {trip.aircraft_model || trip.aircraft_make || "Unknown Aircraft"}
                    </Typography>
                  </Box>
                }
                secondary={
                  <Typography variant="caption" color="text.secondary">
                    {format(startTime, "MMM d, HH:mm")} -{" "}
                    {format(endTime, "MMM d, HH:mm")}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};
